import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    dummyEvent,
    TeaserEventTemplate,
    TeaserEventListTemplate,
} from "./teaser-event.templates";

export default {
    title: "Website/Partial Templates/Teaser/Event",
    render: TeaserEventTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: { ...dummyEvent },
};

export const Default = {};

export const List = {
    render: TeaserEventListTemplate.bind({}),
};
